import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import arePropsEqual from 'react-fast-compare';
import GameCardSeats from '../GameCardSeats/GameCardSeats';
import { NEW, TOP } from '../../../../../constants/tags';
import styles from './GameCardLabels.module.css';

export const NEW_TAG = 'new';
export const TOP_TAG = 'top';

export function GameCardLabels({ tags, gameId, language }) {
  return (
    <div className={styles.labels}>
      {language && <span className={styles.language}>{language}</span>}

      <GameCardSeats
        gameId={gameId}
        className={classNames(styles.label, styles.seats)}
        iconClassName={styles.players}
      />

      {tags?.includes?.(NEW) && (
        <div className={classNames(styles.label, styles.new)}>{NEW_TAG}</div>
      )}
      {tags?.includes?.(TOP) && (
        <div className={classNames(styles.label, styles.top)}>{TOP_TAG}</div>
      )}
    </div>
  );
}

GameCardLabels.propTypes = {
  language: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  gameId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default React.memo(GameCardLabels, arePropsEqual);
